import { useSSRData } from 'hooks';
import { getPlatform } from 'utils';
import getFirstCorrectData from './utils';

const usePlatform = () => {
    const state = useSSRData();
    return getFirstCorrectData(state?.platform, getPlatform(), {});
};

export default usePlatform;
